export default "__VITE_ASSET__D80I5LfL__"